import { render } from "./BroadCastControl.vue?vue&type=template&id=9bfdc8b6&scoped=true&ts=true"
import script from "./BroadCastControl.vue?vue&type=script&lang=ts"
export * from "./BroadCastControl.vue?vue&type=script&lang=ts"

import "./BroadCastControl.vue?vue&type=style&index=0&id=9bfdc8b6&lang=less&scoped=true"
import "./BroadCastControl.vue?vue&type=style&index=1&id=9bfdc8b6&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfdc8b6"]])

export default __exports__